import { AcceportRejectBookingTypes, ACCEPT_OR_REJECT_BOOKING, } from "./ActionTypes";

export const getAcceptorRejectActions = (message: any, status: any,): AcceportRejectBookingTypes => {
    return {
        type: ACCEPT_OR_REJECT_BOOKING,
        message: message,
        status: status,
    };
};